<template>
    <div>
        <div class="nav-header">
<div class="logo">
    <img src="../assets/m-logo.jpg" alt="">
</div>
<div @click="toggleNav()" class="hamb"
>
    <div class="line1"></div>
    <div class="line2"></div>
    <div class="line1"></div>
</div>
        </div>


        <div class="nav" v-show="nav">
            <ul class="topnav">
<router-link to="/" ><li>Home</li></router-link>
<a href="#aboutid">
<li>About</li></a>
<router-link to="/project" ><li>Projects</li></router-link>

<a href="#contactid"><li>Contact</li></a>

            </ul>
        </div>


        <div v-show="mob" class="mob-nav">
            <p @click="toggleNav()">X</p>
 <ul class="mobnav">
     <router-link to="/" ><li @click="toggleNav()"> <span>Home</span> </li>
</router-link>
<a href="#aboutid" ><li @click="toggleNav()"> <span>About</span> </li></a>


<router-link to="/project" > <li @click="toggleNav()">  <span>Projects</span></li></router-link>
<a href="#contactid" ><li @click="toggleNav()"> <span>Contact</span> </li></a>

            </ul>
        </div>
    </div>


</template>


<script>
export default {
    name:'navbar',
    data() {
        return {
            nav:false,
            bar:false,
            mob:false,

        }
    },

    methods:{
toggleNav() {
    this.nav= !this.nav;
    this.mob=!this.mob
},


    }
}
</script>

<style scoped>

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
    .nav-header{
        display: flex;
      
       
    }

    .mob-nav{
        display: none;
    }

    .logo{
width:10%;
margin-left: 3%;
    }

    .logo img{
        width:100%;
    }

    .hamb{
        margin-left: 80%;
        margin-top: 3px;
    }

    .line1{
        border:1px solid black;
        background-color: black;
       
        width: 40px;
        margin-bottom: 8px;
    }

    .line2{
        border:1px solid black;
        background-color: black;
       
        width: 40px;
        margin-bottom: 8px; 
    }

    .nav{
        width: 100%;
        color :#a800e0;
       
        
    }

    .topnav{
        list-style: none;
        font-size: 1.3rem;
        
       
        display: flex;
        background-color: #13001a;
    }

    .topnav li, a{
        margin-left: 10%;
          color :#a800e0;
          text-decoration: none;
          padding-bottom: 1px;

    }

    a:hover{

        border-bottom: 1px solid #a800e0;
    }

    @media only screen and (max-width: 768px){
        .logo{
            width: 30%;

        }

        .hamb{
            margin-left:60% ;
        }

        .nav{
            display: none;
        }

        .mob-nav{
            display: block;
            position: absolute;
            top:0;
            height: 100vh;
            z-index: 1;
            width: 100vw;
            background-color: white;
            color:#a800e0;
        }

        .mob-nav ul{
            list-style: none;
           
            width:100%;
           
            
        }

        .mob-nav p{
            margin-left: 90%;
            font-size: 2rem;
        }


        .mobnav li, a{
            font-size: 1.5rem;
            text-align: left;
            height:50px;
            border-left:none;
            border-right:none;
            border-top:none;
            border-bottom: 1px solid purple;

        }
    }


    @media only screen and (max-width: 576px){
        .logo{
width:20%;
margin-left: 2%;
margin-top: 3px;
    }

    .nav-header{
        margin-top: 15px;
    }
    }
</style>

